<template>
  <div class="section-story-overview">
    <div class="row" :class="{'justify-content-center': centered}">
      <div v-if="$slots.title" class="col-12" :class="{'d-flex justify-content-center align-items-center': centered}">
        <slot name="title"></slot>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6" v-if="$slots.image || background" :class="{'d-flex justify-content-center align-items-center': centered}">
        <slot name="image">
          <div
            v-if="background"
            class="image-container"
            :class="{'image-left': positionText !== 'left' && type === 'only-img', 'image-right': positionText === 'left' && type === 'only-img'}"
            :style="'background-image: url(' + background + ')'"
          ></div>
        </slot>
      </div>
      <div class="col-md-6" v-if="$slots['right-image'] || backgroundRight" :class="{'d-flex justify-content-center align-items-center': centered}">
        <slot name="right-image">
          <div
            v-if="backgroundRight"
            class="image-container"
            :style="'background-image: url(' + backgroundRight + ')'"
          ></div>
        </slot>
      </div>
      <div v-if="$slots['right-text']" class="col-md-6" :class="{'d-flex justify-content-center align-items-center': centered}">
        <div>
          <slot name="right-text"></slot>
        </div>
      </div>
      <div
        v-if="$slots.default"
        class="text-container"
        :class="{ 'col-md-5': type !== 'only-text', 'col-md-6': type === 'only-text', 'inverted': positionText === 'left', 'd-flex justify-content-center align-items-center': centered}"
      >
        <div>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "two-columns",
  props: {
    positionText: {
      type: String,
      default: "right",
      validator(value) {
        return ["left", "right"].includes(value);
      }
    },
    background: String,
    backgroundRight: String,
    centered: Boolean,
    type: {
      type: String,
      default: "img-n-text",
      validator(value) {
        return ["only-text", "img-n-text", "only-img"].includes(value);
      }
    }
  }
};
</script>
<style>
.inverted {
  order: -1;
}

@media screen and (max-width: 767.87px) {
  .text-container {
    order: -1;
  }
}
</style>
